import axios from "axios"
import backend from "./backend"
import getAuthorization from "./getAuthorization"
import customAlert from "@/utils/customAlert"

const request = (endpoint = "", method = "", data = {}, callback = () => {}, callback_error = () => {}) => {
    return new Promise((resolve, reject) => {
        axios({
            method,
            url: `${backend.baseURL}${endpoint}`,
            data,
            headers: { 'Content-Type': 'application/json', ...getAuthorization() },
        })
        .then(response => {
            callback(response)
            resolve(response)
        })
        .catch(async (error) => {
            const status = error.response?.status

            // Tentar renovar o token se for erro de autenticação e ainda não tentou
            if ((status === 401 || status === 403) && !error.config._retry) {
                error.config._retry = true
                const refresh = localStorage.getItem('refresh')

                if (refresh) {
                    try {
                        const res = await axios.post(`${backend.baseURL}refresh-token/`, { refresh })
                        localStorage.setItem('access', res.data.access)
                        // Tenta novamente a request original com novo token
                        const retryResponse = await axios({
                            ...error.config,
                            headers: {
                                ...error.config.headers,
                                Authorization: 'Bearer ' + res.data.access
                            }
                        })
                        callback(retryResponse)
                        resolve(retryResponse)
                        return
                    } catch {
                        customAlert('Session expired. Please login again.', 'd')
                        localStorage.clear()
                        window.location.href = "#/"
                        reject(error)
                        return
                    }
                }

                customAlert('Session expired. Please login again.', 'd')
                localStorage.clear()
                window.location.href = "#/"
                reject(error)
                return
            }

            // Erro 400 com tentativa de exibir mensagem
            if (status === 400) {
                try {
                    const firstError = error.response.data[Object.keys(error.response.data)[0]]
                    customAlert(firstError, 'd')
                } catch {
                    customAlert('Invalid data (Bad request 400)', 'd')
                }
            }

            callback_error(error)
            reject(error)
        })
    })
}

export default request
